/**
 * Subscription Manager
 * Manages subscription expiration state and provides event-based communication
 * between axios interceptor and React components
 */

class SubscriptionManager {
  constructor() {
    this.listeners = new Set();
    this.isExpired = false;
  }

  /**
   * Subscribe to subscription expiration events
   * @param {Function} callback - Function to call when subscription expires
   * @returns {Function} Unsubscribe function
   */
  subscribe(callback) {
    console.log("[SubscriptionManager] New subscriber added. Total listeners:", this.listeners.size + 1);
    this.listeners.add(callback);
    // Don't call immediately - only trigger when 423 status code is received
    // Return unsubscribe function
    return () => {
      this.listeners.delete(callback);
      console.log("[SubscriptionManager] Subscriber removed. Remaining listeners:", this.listeners.size);
    };
  }

  /**
   * Notify all listeners that subscription has expired
   * Prevents duplicate notifications if already expired
   */
  notifyExpired() {
    console.log("[SubscriptionManager] notifyExpired called. Current status:", this.isExpired, "Listeners:", this.listeners.size);
    
    // Only notify if not already expired to prevent duplicate popups
    if (this.isExpired) {
      console.log("[SubscriptionManager] Already expired, skipping notification");
      return;
    }
    
    this.isExpired = true;
    console.log("[SubscriptionManager] Notifying all listeners...");
    this.listeners.forEach((callback, index) => {
      try {
        if (typeof callback === "function") {
          console.log(`[SubscriptionManager] Calling listener ${index + 1}`);
          callback(true);
          console.log(`[SubscriptionManager] Listener ${index + 1} called successfully`);
        } else {
          console.warn(`[SubscriptionManager] Listener ${index + 1} is not a function`);
        }
      } catch (error) {
        console.error(`[SubscriptionManager] Error in subscription listener ${index + 1}:`, error);
      }
    });
    console.log("[SubscriptionManager] All listeners notified");
  }

  /**
   * Reset subscription status (e.g., after successful subscription)
   */
  reset() {
    console.log("[SubscriptionManager] reset() called. Current status:", this.isExpired);
    this.isExpired = false;
    console.log("[SubscriptionManager] Notifying all listeners of reset. Listeners:", this.listeners.size);
    this.listeners.forEach((callback, index) => {
      try {
        if (typeof callback === "function") {
          console.log(`[SubscriptionManager] Calling reset listener ${index + 1}`);
          callback(false);
        }
      } catch (error) {
        console.error(`[SubscriptionManager] Error in reset listener ${index + 1}:`, error);
      }
    });
    console.log("[SubscriptionManager] Reset complete");
  }

  /**
   * Get current expiration status
   */
  getStatus() {
    return this.isExpired;
  }
}

// Export singleton instance
export const subscriptionManager = new SubscriptionManager();

